import axios from 'axios'
import { getApiUrl } from '../app/constants/APIKEYS'
import { message } from 'antd'
export default class API {
	/**
	 * API발송 메소드, /v1 + url
	 */

	static async senddummy(
		method: string,
		url: string,
		token: string | null,
		data: any,
		logout: boolean = true,
		apiurl?: string
	) {
		try {
			let headers = this.getHeaders(token)
			let options = this.getOptions(method, headers, data)

			let res = [
				{
					market: 'KRW-BTC',
				},
			]
			return res
		} catch (e) {
			console.error('ERRORAPI', method, url, e)
			if (logout) this.forceLogout()
		}
	}

	static async send(
		method: string,
		url: string,
		token: string | null,
		data: any,
		logout: boolean = true,
		apiurl?: string | null
	) {
		try {
			let headers = this.getHeaders(token)
			let options = this.getOptions(method, headers, data)
			let requrl = (apiurl ? apiurl : getApiUrl()) + url

			let res = await fetch(requrl, options)
				.then(res => {
					return res.json()
				})
				.then(res => {
					if (res.code === 503) {
						console.error('ERRORAPI503', method, url)
						if (logout) this.forceLogout()
					}
					return res
				})
			return res
		} catch (e) {
			console.error('ERRORAPI', method, url, e)
		}
	}


	
	static async external(
		method: string,
		url: string,
		token: string | null,
		data: any,
		logout: boolean = true,
		apiurl?: string | null
	) {
		try {
			let headers = this.getHeaders(token)
			let options = this.getOptions(method, headers, data)
			let requrl =  url

			let res = await fetch(requrl, options)
				.then(res => {
					return res.json()
				})
				.then(res => {
					if (res.code === 503) {
						console.error('ERRORAPI503', method, url)
						if (logout) this.forceLogout()
					}
					return res
				})
			return res
		} catch (e) {
			console.error('ERRORAPI', method, url, e)
		}
	}
	static async getL(
		url: string,
		token: string | null,
		data: any,
		logout: boolean = true,
		apiurl?: string | null
	) {
		return this.send('GET', url, token, data, logout, apiurl)
	}
	static async get(
		url: string,
		token: string | null,
		data: any,
		logout: boolean = true,
		apiurl?: string | null
	) {
		return this.send('GET', url, token, data, false, apiurl)
	}
	static async post(
		url: string,
		token: string | null,
		data: any,
		apiurl?: string
	) {
		return this.send('POST', url, token, data, true, apiurl)
	}
	static async delete(
		url: string,
		token: string | null,
		data: any,
		apiurl?: string
	) {
		return this.send('DELETE', url, token, data, true, apiurl)
	}
	static async put(
		url: string,
		token: string | null,
		data: any,
		apiurl?: string
	) {
		return this.send('PUT', url, token, data, true, apiurl)
	}

	static async getPublic(url: string) {
		return this.send('GET', url, null, {})
	}
	static async postPublic(url: string, data: any) {
		return this.send('POST', url, null, data)
	}
	static async deletePublic(url: string, data: any) {
		return this.send('DELETE', url, null, data)
	}
	static async putPublic(url: string, data: any) {
		return this.send('PUT', url, null, data)
	}

	static async refreshToken(token: string) {
		try {
			if(!token) return false

			let options = this.getOptions('POST', this.getHeaders(token), {
				token,
			})
			// let res = await fetch(API_URL + '/auth/refresh', options)
			// 	.then(res => {
			// 		return res.json()
			// 	})
			// 	.then(res => {
			// 		if (res.code !== 0) {
			// 			return false
			// 		}
			// 		return res
			// 	})
			// return res
		} catch (e) {
			console.error('REFRESH', e)
		}
	}

	static getHeaders(token: string | null) {
		const headers: any = token
			? {
					Authorization: 'Bearer ' + token,
					'Content-Type': 'application/json',
			  }
			: {
					'Content-Type': 'application/json',
			  }
		return headers
	}

	static getOptions(method: string, headers: any, data?: any): any {
		const options =
			method.toLocaleUpperCase() === 'GET'
				? {
						method: method,
						headers: headers,
				  }
				: {
						method: method,
						headers: headers,
						body: JSON.stringify(data),
				  }
		return options
	}

	static forceLogout() {
		window.location.href = '/logout'
	}
}

export const loadData = async (number?: any) => {
	const result = await axios.get('https://api.upbit.com/v1/market/all')
	const newResult = number ? result?.data?.slice(0, number) : result?.data
	return newResult?.filter((d: any) => d.market?.match(/^KRW+/))
}
